import type { CSSProperties } from 'react'
import { CARDS_WITH_ART } from '../../../shared/cardArtManifest.ts'

/**
 * Иллюстрации карт.
 *
 * Источник — колода Райдера — Уэйта — Смит 1909 года (Памела Колман Смит,
 * ум. 1951), общественное достояние. Файлы готовит `scripts/fetch-cards.ts`:
 * он же обрезает белое поле и полосу с английским названием карты, так что
 * здесь картинку остаётся только показать.
 */

/**
 * Карта без иллюстрации показывается символом масти: список ведёт скрипт по
 * файлам на диске, так что пропуски не превращаются в битые картинки.
 */
export function hasArt(cardId: number): boolean {
  return CARDS_WITH_ART.has(cardId)
}

/** Путь к иллюстрации: `sm` для мелких карт в раскладе, `lg` для крупных. */
export function artUrl(cardId: number, size: 'sm' | 'lg'): string {
  return `/cards/${cardId}-${size}.jpg`
}

/**
 * Пропорции карты в вёрстке и пропорции рисунка совпадают неточно, поэтому
 * заполняем рамку с обрезкой по краям, а не оставляем поля.
 */
export const artImageStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}
